module.exports = __webpack_public_path__ + "img/35.11bee97a.jpg";